import { isoZ, z } from 'my-zod'

export const outfitterBlackoutDateModel = z.object({
  outfitterId: z.number(),
  date: isoZ.date(),
  description: z.string().max(120),
  createdDate: isoZ.instant()
})

export type outfitterBlackoutDateModel = z.infer<typeof outfitterBlackoutDateModel>
